import { styled } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import BorderHeading from '../../components/heading/BorderHeading'
import ConfigurationHeader from '../../components/heading/ConfigurationHeader'
import Input from '../../components/Input/Input'
import { configurationAttributeType, newConfigurationNames, themeConfigurationValuesTypes } from '../../types'
import { HexColorPicker } from "react-colorful";
import "./ThemeConfiguration.css"
import { convertValuesToConfig, createValidation, doFinalConfigSubmit, getMetaDataConfig, getNewConfiguration, overWriteConfig, postConfiguration, updateConfiguration } from '../../services/uiConfigService'
import * as yup from 'yup'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeDropper } from "@fortawesome/free-solid-svg-icons";
import * as Sentry from "@sentry/react";
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions'
import { manageUpdateAccessObj } from '../manageUpdateAccess/manageUpdateAccessTypes'
import { openPopup } from '../../stateManagement/actions/popupActions'
import { defaultThemeValues } from '../defaultConfigurations/themeConfigDefaultValues'
import ConfigComparePopup from '../../components/popup/ConfigComparePopup'
import ImportConfig from '../../components/importConfig/ImportConfig'
import { deepClone } from '@mui/x-data-grid/utils/utils'



const ThemeConfiguration = (props:{showBackButton?:boolean}) => {
  const [themeConfig, setThemeConfig] = useState<configurationAttributeType[]>([]);
  const [values, setValues] = useState<themeConfigurationValuesTypes>(deepClone(defaultThemeValues))
  const [themeValidationsSchema, setThemeValidationSchema] = useState({})
  const [toggleColorInput, setToggleColorInput] = useState({
    themeColor: true,
    // themeBackGroundColor: true,
    themeDisabledButtonColor: true,
    // activeLanguageColor:true,
  });
  const [inputColor, setInputColor] = useState({
    themeColor: '',
    // themeBackGroundColor: '',
    themeDisabledButtonColor: '',
    // activeLanguageColor: '',
  });

  const [showConfigPopup,setShowConfigPopup] = useState<boolean>(false);
  const curConfigRef = useRef<{[key:string]:any[]}>({});
  const newConfigRef = useRef<{[key:string]:any[]}>({});
  
  const getThemeConfiguration = async () => {
    try {
      const resp = await getNewConfiguration('theme_configuration');
      const theme_config: configurationAttributeType[] = resp?.domainValues;
      curConfigRef.current.theme_configuration = theme_config ?? [];
      setThemeConfig([...theme_config])
    } catch (err) {
      // Sentry.captureException(err);
    }
  }
  useEffect(() => {
    getThemeConfiguration();
  }, [])

  interface WrapperProps extends React.HTMLAttributes<HTMLDivElement> {
    callback?: Function
  }

  const Picker = (props: WrapperProps) => {

    const Wrapper = styled('span')(`
      width:2.5rem!important;
      padding-top:1rem;
      padding-bottom:1rem;
      border:#a2a9b0 solid 1px;
      display:flex;
      justify-content:center;
      align-items:center;
      border-radius:0.15rem
      `)
    return <Wrapper {...props}><FontAwesomeIcon color='#a2a9b0' icon={faEyeDropper} /></Wrapper>
  }
  const isValidHexColor = (colorString: string) => {
    if (colorString.length < 6) {
      return false;
    }
    return /^[0-9A-Fa-f]{6}$/i.test(colorString);
  };
  const saveConfiguration = async (preview?: boolean) => {

      try {
        let result:themeConfigurationValuesTypes = {...values};
        // if (toggleColorInput.themeColor || toggleColorInput.themeDisabledButtonColor) {
        //   result.themeColor.value = toggleColorInput.themeColor ? inputColor.themeColor : result.themeColor.value;
        //   result.themeDisabledButtonColor.value = toggleColorInput.themeDisabledButtonColor ? inputColor.themeDisabledButtonColor : result.themeDisabledButtonColor.value;
        // }
        const themeSchema = yup.object({ ...themeValidationsSchema })
        const validationObject:any = {};
        Object.keys(result).forEach(key=>{
            validationObject[key] = result[key].value;
        })
        // await themeSchema.validate(validationObject)
        const convertedVals = convertValuesToConfig(result, themeConfig);
        newConfigRef.current.theme_configuration = convertedVals;
        setShowConfigPopup(true);
      } catch (err) {
        // Sentry.captureException(err);
        console.log("err===", err)
        openPopup('Error',"Validation Error occured")
      }
  }

  const handleColorInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const keyName = e.target.name;
    if(isValidHexColor(e.target.value)){
      setValues({ ...values, [e.target.name]: {...values[keyName],value:e.target.value, isValueUpdated:true} })
    }
    setInputColor({ ...inputColor, [e.target.name]: e.target.value })
  }

  const  onConfigComparatorSuccess=async () => {
    await doFinalConfigSubmit("theme_configuration",newConfigRef.current.theme_configuration,curConfigRef)
    getThemeConfiguration();
  }

  useEffect(()=>{
    const withoutHashValues = withoutHash(values);
    setInputColor({ ...withoutHashValues })
  },[values])

  const withoutHash=(result:themeConfigurationValuesTypes)=>{
    const withoutHash = {
      themeColor: '',
      // themeBackGroundColor: '',
      themeDisabledButtonColor: '',
      // activeLanguageColor:'',
    };
    let color: keyof typeof withoutHash;
    for (color in withoutHash) {
      const hexcode = result[color]?.value?.split('#')[1] ? result[color]?.value?.split('#')[1] : result[color].value;
      withoutHash[color] = hexcode;
    }
    return withoutHash;
  }
  const setThemeConfigValues = () => {
    try {
      if (themeConfig.length) {
        const result = { ...values };
        const resValidations = {} as { [key: string]: ReturnType<typeof createValidation> }
        themeConfig.forEach((attr) => {
          resValidations[attr.name] = createValidation(attr)
          result[attr.name] = attr;
        })
        setValues({ ...result });
        const withoutHashValues = withoutHash(result);
        setInputColor({ ...withoutHashValues })
        setThemeValidationSchema({ ...resValidations })
      }
    } catch (err) {
      // Sentry.captureException(err);
    }
  }

  useEffect(() => {
    setThemeConfigValues()
  }, [themeConfig])

  const showColorStyle = (color: string) => { return { backgroundColor: color ? color.includes("#") ? color : "#" + color : "transparent", width: "3rem", height: "1.8rem", borderRadius: '0.2rem', marginLeft: '1rem' } }

  const importConfiguration = async (importedConfig:any)=>{
    const newConfigs = await overWriteConfig(importedConfig, {
      theme_configuration:"importAll"
    })
    newConfigs.forEach((item) => {
      newConfigRef.current[item.domainType] = item.domainValues;
  });
  setShowConfigPopup(true);
  }
  const [importConfigState,setImportConfigState] = useState(false);


  return (
    <div className="theme_config_container">
      <ImportConfig importConfigState={importConfigState} setImportConfigState={setImportConfigState} configNames={['theme_configuration']} importConfigCallback={importConfiguration} />
      <ConfigurationHeader heading={"Theme Configuration"} showBackButton={props.showBackButton} importConfiguration={()=>{setImportConfigState(true)}} saveConfiguration={() => saveConfiguration(false)}/>
      <div className="config_form_container">
        <div className="form_header">
          <BorderHeading>Enter the hexcode of the Theme Color</BorderHeading>
        </div>
        <div className="color_picker_container"> 
              <div>{!toggleColorInput?.themeColor && <HexColorPicker color={values.themeColor.value} onChange={(newColor) => setValues({ ...values, themeColor: {...values.themeColor,value:newColor, isValueUpdated:true} })} />} <span style={{ width: "60%" }}> <Input value={inputColor.themeColor} name={'themeColor'} inputProps={{ maxLength: 6 }} onChange={handleColorInputChange} /></span></div>
          <Picker style={showColorStyle(values.themeColor.value)} onClick={(e) => setToggleColorInput({ ...toggleColorInput, themeColor: !toggleColorInput.themeColor })} />
        </div>
        {/* <div className="form_header">
          <BorderHeading>Enter the hexcode of the Background theme Color</BorderHeading>
        </div>
        <div className="color_picker_container">
          {
            toggleColorInput?.themeBackGroundColor ? <span style={{ width: "60%" }}> <Input value={inputColor.themeBackGroundColor} name="themeBackGroundColor" inputProps={{ maxLength: 6 }} onChange={handleColorInputChange} /></span>
              :
              <div><HexColorPicker color={values.themeBackGroundColor.value} onChange={(newColor) => setValues({ ...values, themeBackGroundColor:  {...values.themeBackGroundColor,value:newColor, isValueUpdated:true} })} /> <div style={{ color: values.themeBackGroundColor.value ? values.themeBackGroundColor.value : 'black', marginTop: '1rem', fontSize: "1.5rem" }}>{values.themeBackGroundColor.value}</div></div>
          }
          <Picker style={showColorStyle(inputColor.themeBackGroundColor)} onClick={(e) => setToggleColorInput({ ...toggleColorInput, themeBackGroundColor: !toggleColorInput.themeBackGroundColor })} />

        </div> */}
        
        {/* <div className="form_header">
          <BorderHeading>Enter the hexcode of the Theme disabled button color</BorderHeading>
        </div>
        <div className="color_picker_container">
          {
            toggleColorInput?.themeDisabledButtonColor ? <span style={{ width: "60%" }}> <Input value={inputColor.themeDisabledButtonColor} name="themeDisabledButtonColor" inputProps={{ maxLength: 6 }} onChange={handleColorInputChange} /></span>
              :
              <div><HexColorPicker color={values.themeDisabledButtonColor.value} onChange={(newColor) => setValues({ ...values, themeDisabledButtonColor: {...values.themeDisabledButtonColor,value:newColor, isValueUpdated:true} })} /> <div style={{ color: values.themeDisabledButtonColor.value ? values.themeDisabledButtonColor.value : 'black', marginTop: '1rem', fontSize: "1.5rem" }}>{values.themeDisabledButtonColor.value}</div></div>
          }
          <Picker style={showColorStyle(inputColor.themeDisabledButtonColor)} onClick={(e) => setToggleColorInput({ ...toggleColorInput, themeDisabledButtonColor: !toggleColorInput.themeDisabledButtonColor })} />
        </div> */}

        {/* <div className="form_header">
          <BorderHeading>Enter the hexcode of the active language color</BorderHeading>
        </div>
        <div className="color_picker_container">
          {
            toggleColorInput?.activeLanguageColor ? <span style={{ width: "60%" }}> <Input value={inputColor.activeLanguageColor} name="activeLanguageColor" inputProps={{ maxLength: 6 }} onChange={handleColorInputChange} /></span>
              :
              <div><HexColorPicker color={values.activeLanguageColor.value} onChange={(newColor) => setValues({ ...values, activeLanguageColor: {...values.activeLanguageColor,value:newColor, isValueUpdated:true} })} /> <div style={{ color: values.activeLanguageColor.value ? values.activeLanguageColor.value : 'black', marginTop: '1rem', fontSize: "1.5rem" }}>{values.activeLanguageColor.value}</div></div>
          }
          <Picker style={showColorStyle(inputColor.activeLanguageColor)} onClick={(e) => setToggleColorInput({ ...toggleColorInput, activeLanguageColor: !toggleColorInput.activeLanguageColor })} />
        </div> */}
      </div>
      <ConfigComparePopup message="Are you sure want to update the config" showConfigPopup={showConfigPopup} setShowConfigPopup={setShowConfigPopup} curConfig={curConfigRef.current} newConfig={newConfigRef.current} onSuccess={onConfigComparatorSuccess}/>
    </div>
  )
}

export default ThemeConfiguration